var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 11.832V18.832C26.5 23.4987 25.25 24.6654 20.25 24.6654H7.75C2.75 24.6654 1.5 23.4987 1.5 18.832V7.16536C1.5 2.4987 2.75 1.33203 7.75 1.33203H9.625C11.5 1.33203 11.9125 1.84536 12.625 2.73203L14.5 5.06536C14.975 5.6487 15.25 5.9987 16.5 5.9987H20.25C25.25 5.9987 26.5 7.16536 26.5 11.832Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.5f8f5b694eb7d5b4956fb4270a1a1784.svg";
export { ForwardRef as ReactComponent };